import React, { Suspense, useEffect } from "react";
import "./global.css";
import "./App.css";
import { Loader } from "./component";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import CalculatorLayout from "./pages/layout/CalculatorLayout";
import {
  AdminProfiles,
  Appliances,
  Calculator,
  CustomerDetails,
  Customers,
  Dashboard,
  Login,
  Settings,
  StockOut,
} from "./pages";
import AdminLayout from "./pages/admin/layout";
import ProtectedRoutesProvider from "./context/ProtectedRoutes";
import Inventory from "./pages/admin/Inventory";

const NotFound = () => {
  useEffect(() => {
    window.location.href = 'https://server.revocube.com/errorpages/404.html';
  }, []);

  return null;
};

function App() {
  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <CalculatorLayout />,
        children: [
          {
            path: "",
            element: <Calculator />,
          },
          {
            path: "admin",
            element: <Login />,
          },
        ],
      },
      {
        path: "/admin",
        element: <AdminLayout />,
        children: [
          {
            path: "dashboard",
            element: <Dashboard />,
          },
          {
            path: "appliances",
            element: <Appliances />,
          },
          {
            path: "inventory",
            element: <Inventory />,
          },
          {
            path: "customers",
            element: <Customers />,
          },
          {
            path: "orders",
            element: <StockOut />,
          },
          {
            path: "Settings",
            element: <Settings />,
          },
          {
            path: "customers/:userId",
            element: <CustomerDetails />,
          },
          {
            path: "profiles",
            element: <AdminProfiles />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
    {
      basename: "/energy-calculator",
    }
  );

  return (
    <Suspense fallback={<Loader spin />}>
      <ProtectedRoutesProvider>
        <RouterProvider router={router} />
      </ProtectedRoutesProvider>
    </Suspense>
  );
}

export default App;
